<template>
  <div>
    <div class="header">
      <img src="../assets/logo.png" alt="" @click="gotoHome" />
      <div class="textGroup">
        <div class="text text1" @click="goAnchor('/', '#anchor0')">首页</div>
        <div class="text text1" @click="goAnchor('/', '#anchor1')">产品中心</div>
        <div class="text text1" @click="goAnchor('/', '#anchor2')">成功案例</div>
        <div class="text text2" @click="goAnchor('/', '#anchor3')">关于我们</div>
      </div>
    </div>
  </div>
</template>
<script>
import router from '../router/index'
export default {
  methods: {
    goAnchor(page, selectID) {
      console.log(this.$route.path, "this.$route.path");
      if (page == this.$route.path) {  //如果当前已经在这个页面不跳转 直接去
        let toElement = document.getElementById(selectID);
        toElement.scrollIntoView(true);
      } else {  //否则跳转路由
        localStorage.setItem("toId", selectID);
        this.$router.push({ path: page });
      }
    },
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>
  .header {
  position: absolute;
  display: flex;
  background-color: #000;
  z-index: 2;
  height: 75px;
  top: 0;
  width: 100%;
  font-family: SimHei;
}
.header img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue